module.exports = __webpack_public_path__ + "f23cd413c45fdbef6f4c5578997f0edf.jpg";